import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import DischargeAdviceList from "./Phase-07/DischargeAdvice/DischargeAdviceList";
import Breadcrumbs from "../components/common/Breadcrumbs";
import {
    fetchDischargeAdvices,
    deleteDischargeAdvice,
    clearError,
} from "../store/slices/dischargeAdviceSlice";
import Swal from "sweetalert2";

const DischargeAdvices = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { dischargeAdvices, isLoading, error } = useSelector(
        (state) => state.dischargeAdvice
    );

    useEffect(() => {
        dispatch(clearError());
        dispatch(fetchDischargeAdvices());
    }, [dispatch]);

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This discharge advice will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteDischargeAdvice(id)).unwrap();
                Swal.fire("Deleted!", "Discharge advice removed.", "success");
            } catch (err) {
                Swal.fire("Error", err || "Failed to delete.", "error");
            }
        }
    };

    if (isLoading) {
        return (
            <MainLayout>
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading discharge advices...</p>
                        </div>
                    </div>
                </div>
            </MainLayout>
        );
    }

    if (error) {
        return (
            <MainLayout>
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="card">
                        <div className="card-body">
                            <div className="alert alert-danger">
                                <strong>Error:</strong> {error}
                            </div>
                        </div>
                    </div>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <DischargeAdviceList
                        records={dischargeAdvices}
                        onAdd={() => navigate("/phase07/discharge-advice/add")}
                        onEdit={(id) => navigate(`/phase07/discharge-advice/edit/${id}`)}
                        onDelete={handleDelete}
                    />
                </div>
            </div>
        </MainLayout>
    );
};

export default DischargeAdvices;